

// redux/actions/districtsActions.js
import axios from "axios";
import { toast } from "react-hot-toast";

export const FETCH_DISTRICTS_REQUEST = "FETCH_DISTRICTS_REQUEST";
export const FETCH_DISTRICTS_SUCCESS = "FETCH_DISTRICTS_SUCCESS";
export const FETCH_DISTRICTS_FAILURE = "FETCH_DISTRICTS_FAILURE";

export const CREATE_DISTRICT_REQUEST = "CREATE_DISTRICT_REQUEST";
export const CREATE_DISTRICT_SUCCESS = "CREATE_DISTRICT_SUCCESS";
export const CREATE_DISTRICT_FAILURE = "CREATE_DISTRICT_FAILURE";


export const UPDATE_DISTRICT_REQUEST = "UPDATE_DISTRICT_REQUEST";
export const UPDATE_DISTRICT_SUCCESS = "UPDATE_DISTRICT_SUCCESS";
export const UPDATE_DISTRICT_FAILURE = "UPDATE_DISTRICT_FAILURE";



// Fetch all districts
export const fetchDistricts = () => async (dispatch) => {
  dispatch({ type: FETCH_DISTRICTS_REQUEST });

  try {
    const token = localStorage.getItem("token");
    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/v1/api/get-districts-admin`,
      {
        headers: {
          Authorization: token,
        },
      }
    );

    dispatch({
      type: FETCH_DISTRICTS_SUCCESS,
      payload: res.data?.data || [],
    });
  } catch (error) {
    const errorMessage =
      error?.response?.data?.meta?.message || "Failed to fetch districts";

    dispatch({
      type: FETCH_DISTRICTS_FAILURE,
      payload: errorMessage,
    });

    toast.error(errorMessage);
  }
};

// Create a new district
export const createDistrict = (districtData) => async (dispatch) => {
  dispatch({ type: CREATE_DISTRICT_REQUEST });

  try {
    const token = localStorage.getItem("token");
    const res = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/v1/api/create-district`,
      districtData,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );

    dispatch({
      type: CREATE_DISTRICT_SUCCESS,
      payload: res.data.data,
    });

    toast.success(res?.data?.meta?.message || "District created successfully");

    // Optionally re-fetch districts after creation
    dispatch(fetchDistricts());
  } catch (error) {
    const errorMessage =
      error?.response?.data?.meta?.message || "Failed to create district";

    dispatch({
      type: CREATE_DISTRICT_FAILURE,
      payload: errorMessage,
    });

    toast.error(errorMessage);
  }
};


export const updateDistrict = (districtData) => async (dispatch) => {
  dispatch({ type: UPDATE_DISTRICT_REQUEST });

  try {
    const token = localStorage.getItem("token");
    const res = await axios.put(
      `${process.env.REACT_APP_API_BASE_URL}/v1/api/update-district`,
      districtData,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );

    dispatch({ type: UPDATE_DISTRICT_SUCCESS, payload: res.data.data });

    toast.success(res?.data?.meta?.message || "District updated successfully");

    dispatch(fetchDistricts()); // Refresh list
  } catch (error) {
    const errorMessage =
      error?.response?.data?.meta?.message || "Failed to update district";

    dispatch({ type: UPDATE_DISTRICT_FAILURE, payload: errorMessage });

    toast.error(errorMessage);
  }
};